//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import SchedulingFormModule from 'app_components/modules/admin/landings/schedulingForm/index';
import ReferenceFormModule from 'app_components/modules/admin/landings/referencesForm/index';
//@end

// @import hooks
// @end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../studentLandingModule.scss'

// @ADD Component types
interface IStudentLandingModuleLayoutProps {
  permission: any
  onHandleSchedulingSubmit: (data: any) => void | null
  landingInfo: ILanding | null
  loadingForm: 'loading' | null
}

const StudentLandingModuleLayout: React.FC<IStudentLandingModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [listOfSchedulings, setListOfSchedulings] = useState<Array<any>>([])

  useEffect(() => {
    let schedulings: Array<any> = []
    if (props.landingInfo?.landing?.scheduling && props.landingInfo?.landing?.scheduling.length > 0) {
      schedulings = props.landingInfo?.landing?.scheduling
    }
    setListOfSchedulings(schedulings)
  }, [props.landingInfo?.landing?.scheduling])

  return(
    <div className='student_landing_module-layout'>
      {/* ========== Nuestras referencias =============== */}
      <ReferenceFormModule
        data={props.landingInfo?.landing?.references}
        source='student'
        onHandleSaved={props.onHandleSchedulingSubmit}
        landingInfo={props.landingInfo}
      />
      {/* ========== Programaciones =============== */}
      <SchedulingFormModule
        source='student'
        listOfSchedulings={listOfSchedulings}
        onHandleSchedulingSubmit={props.onHandleSchedulingSubmit}
      />
    </div>
  )
}

export default StudentLandingModuleLayout
